import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CONFIG } from './config';
import { reloadOnceForStaleChunk } from './utils/staleChunkReload';
import { initPostHog } from './services/posthog';

initPostHog();

// Vite emits this when a dynamically-imported chunk 404s (stale build after a redeploy).
window.addEventListener('vite:preloadError', () => {
  reloadOnceForStaleChunk();
});

if (CONFIG.DEBUG_FRONTEND_LOGS) {
  console.info('[bootstrap] NuGuard frontend initializing', {
    href: window.location.href,
    origin: window.location.origin,
    hash: window.location.hash,
    userAgent: navigator.userAgent,
    dataServiceUrl: CONFIG.DATA_SERVICE_URL,
    assetsServiceUrl: CONFIG.ASSETS_SERVICE_URL,
    complianceServiceUrl: CONFIG.COMPLIANCE_SERVICE_URL,
    mockMode: CONFIG.USE_MOCK_MODE,
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
